export default __webpack_public_path__ + "static/media/lines_color_up_right.f723bddb.png";